



















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {  postData, putData, LawFileData, emptyLawFile, getInfo
} from '@/api/lawFile/index'
import { enFirstType } from '@/configs/enums'
import { DDLItem } from '@/api/common/select'
import { validateIntKey } from '@/configs/validate'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import singleFile from '@/components/upload/singleFile.vue'
import PageForm from '@/components/pageLayout/form.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    LawFileTitle: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
    ClassifyId: [{ required: true, validator: validateIntKey('请选择文件类型'), trigger: 'change' }],
    Status: [{ required: true, validator: validateIntKey('请选择文件状态'), trigger: 'change' }],
    // LawContent: [{ required: true, message: '请输入公告内容', trigger: 'blur' }],
    // LawFileCode: [{ required: true, message: '请输入公告单位', trigger: 'blur' }],    
    AttachPath: [{ required: true, message: '请上传附件' }]
  }
}

@Component({
  components: {
    PageForm, singleFile
  }
})
export default class FileLawForm extends Vue {
  public collapseNames: string[] = ['base', 'contents', 'attachs']
  public name = 'FileLawForm'
  public loading = false

  public form: LawFileData = Object.assign({}, emptyLawFile)
  public firstType: number = enFirstType.Select
  public classifyList: DDLItem[] = []
  public statusList: DDLItem[] = []

  public editorContainerCls = ""
  public editorOption = {
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['clean'],
        ['link']
      ]
    },
    placeholder: '请输入文件内容',
  }
  onEditorBlur() {
    this.editorContainerCls = ''
    this.$refs.formCtrl.validateField('LawContent')
  }
  onEditorFocus() {
    this.editorContainerCls = 'editor-focused'
  }
  onEditorReady() {
  }

  // #endregion
  public rules: any = getFormRules(0, this.form)
  // dynamic component
  public $refs!: {
    // formData: Element.Form
    formCtrl: PageForm
  }
  //页面第一次加载的时候，不要校验。
  public checkAttach: boolean = false
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    this.form.AttachPath = data.file.SavePath
    if (this.checkAttach) {
      this.$refs.formCtrl.validateField('AttachPath')
    }
    else {
      this.checkAttach = true
    }
  }
  public onFileClick(data: { opts: UploadOptData, file: AttachInfo }) {
    console.log('onFileClick', data)
  }

  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.classifyList = data.classifyList
      this.statusList = data.statusList
    }
  }
  public created() {
    this.fetchSource()
  }
  public mounted() {
    this.fetchData()
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchLawFile(id)
  }
  public fetchLawFile(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.rules = getFormRules(this.form.Id, this.form)
      if (this.form.Id == 0) {
        this.$refs.formCtrl.clearValidate()
      }
      this.loading = false
    })
  }
  public onCancel() {
    this.$router.push({ path: '/LawFile' })
  }
  public onSubmit() {
    this.saveData()
    // this.$refs.elForm.validate((valid: boolean, obj: any) => {
    //   if (valid) {
    //     this.saveData()
    //   } else {
    //     showVaildMsg(this.$message, obj)
    //   }
    // })
  }

  public async saveData() {
    var f = this.form
    const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
    promist.then((response: { data: any }) => {
      const data = response.data
      const msg = this.form.Id > 0 ? '保存' : '创建'
      if (data && !data.IsError) {
        this.$message({
          message: `${msg}成功`,
          type: 'success'
        })
        this.$router.push({ path: '/LawFile' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
        console.log(response)
      }
    })
  }
}
